<div class="tt-c-multi-items">
  <p id="tt-multi-items-text" class="tt-c-multi-items__text">{{promptText}}</p>
  <tt-button ref="openSearchBtn" type="compact-text" @click="openSearch()" class="tt-c-multi-items__add-items" aria-describedby="tt-multi-items-text"
    aria-haspopup="true" v-html="$msg('multiItem.addItems')"></tt-button>
  <div class="tt-c-multi-items__container">
    <div v-for="item in multiItems" class="tt-c-multi-items__item" :key="item.id">
      <button type="button" class="tt-c-multi-items__remove tt-o-button--action-icon-chip" @click="removeItem(item)" :aria-label="$msg('multiItem.removeItem', [item.title])">
        <tt-icon name="close"></tt-icon>
      </button>
      <tt-product-image :catItem="item"></tt-product-image>
    </div>
  </div>
  <tt-modal v-if="showMultiItemSearch" 
            class="tt-o-multi-items-popover" 
            @close="closeSearch"
            :closeLabel="$msg('multiItemSearch.popoverCloseLabel')"
            :aria-label="$msg('multiItemSearch.popoverLabel')">
    <tt-multi-item-search @addItems="addItemsAndClose" :excludedCatItemIds="searchExcludedCatItemIds" :sku="sku"></tt-multi-item-search>
  </tt-modal>
</div>
